export const SezioniAuthGuard = [
    { section: 'Anagrafica pazienti' },
    { section: 'Dettagli' },
    { section: 'Visite' },
    { section: 'Osservazioni' },
    { section: 'Esame obiettivo' },
    { section: 'Trattamenti e procedure' },
    { section: 'Gestione utenti' }
];
